/**
 * deviceFp.js — Impressão digital do dispositivo (FingerprintJS OSS) para o
 * antifraude dos 3 áudios free. Usado SÓ no fluxo free: vai no header X-Device-FP
 * do /usage, no body do /audio-tts/generate e no body do /auth/google.
 *
 * Cache em MEMÓRIA por carga de página — NÃO em localStorage de propósito: o
 * visitorId é determinístico do dispositivo, então cachear em storage só permitiria
 * um spoof trivial (trocar a chave = "novo aparelho"). Recalcular é barato (~uma vez
 * por carga). Em caso de falha, resolve null → backend trata como esgotado (fail-closed).
 */
import FingerprintJS from '@fingerprintjs/fingerprintjs';

let _cached = null;
let _loading = null;

export async function getDeviceFp() {
  if (_cached) return _cached;
  if (!_loading) {
    _loading = FingerprintJS.load()
      .then((fp) => fp.get())
      .then((res) => { _cached = res.visitorId; return _cached; })
      .catch(() => null);
  }
  return _loading;
}

export default getDeviceFp;
